import { render, staticRenderFns } from "./ead-relatorio-progresso.vue?vue&type=template&id=829737da&scoped=true&"
import script from "./ead-relatorio-progresso.vue?vue&type=script&lang=js&"
export * from "./ead-relatorio-progresso.vue?vue&type=script&lang=js&"
import style0 from "./ead-relatorio-progresso.vue?vue&type=style&index=0&id=829737da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829737da",
  null
  
)

export default component.exports